import { Component, OnInit } from '@angular/core';
import { BookingEmailTemplate } from '../booking-email-template';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-booking-email-templates',
  templateUrl: './booking-email-templates.component.html',
  styleUrls: ['./booking-email-templates.component.css']
})
export class BookingEmailTemplatesComponent implements OnInit {

  templates: BookingEmailTemplate[] = [];
  activeTemplates: BookingEmailTemplate[] = [];
  languages: Language[] = [];
  activeLanguages: SelectItem[] = [];
  selectedLanguage!: Language;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
      this.activeLanguages.push({ label: "All", value: new Language(0, "All") });
      this.selectedLanguage = this.activeLanguages[0].value;
      for (let language of this.languages) {
        this.activeLanguages.push({ label: language.name, value: { id: language.id, name: language.name } });
      }
      console.log(this.activeLanguages);
    });
    this.httpService.getBookingEmailTemplates().subscribe(res => {
      this.templates = res;
      this.activeTemplates = res;
      console.log(res);
    });
  }

  updateSelectedLanguage() {
    if (this.selectedLanguage.id == 0) {
      this.activeTemplates = this.templates;
    } else {
      this.activeTemplates = this.templates.filter(template => {
        return template.language.id == this.selectedLanguage.id;
      });
    }
  }
}
